import { render, staticRenderFns } from "./AmenitiesUpdateModal.vue?vue&type=template&id=2c5191e4&"
import script from "./AmenitiesUpdateModal.vue?vue&type=script&lang=js&"
export * from "./AmenitiesUpdateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports